/* tslint:disable:typedef-whitespace align no-trailing-whitespace no-inferrable-types */

import { Action, ActionType    } from '@/models/action';
import { Logger                } from '@/util/logger';
import { Project               } from '@/models/project';
import { ProjectFactory        } from '@/models/project.factory';
import { ServiceManager        } from "@/services/service.manager";
import { first                 } from 'rxjs/operators';

/**
 *
 * @class ProjectOpenRecentAction
 *
 * @brief custom version 'Open Project'; allows us to cache recent projects
 * to re-open on demand. These instances are not managed by the action service;
 * they are just used directly in the menu component, and dynamically created
 * and deleted as the project access history changes.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class ProjectOpenRecentAction extends Action {

  private pkey: string = '';

  constructor(
    private services: ServiceManager,
                name: string = '',
                 key: string = ''
  ) {

    super({
      key:   'project.open.recent',
      type:  ActionType.Project_Open,
      label: 'Re-Open',
      icon:  '',
      tip:   'Open a recent project'
    });

    this.label = name;
    this.pkey  = key;
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    /* recover the JSON data for the project from disk... */

    this.services.blobber.contents(this.pkey)
      .pipe(first())
      .subscribe(
        contents => {

          const project: Project = ProjectFactory.fromJSON(contents as string) as Project;

          Logger.debug('[ProjectOpenRecentAction] opening project: ', project);

          this.services.projects.openProject(project);
        },
        error => {

          Logger.error('[ProjectOpenRecentAction] can not fetch project data: ', error);

        });

    return true;
  }
}
